(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4800],{

/***/ 3276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop",
      function () {
        return __webpack_require__(6830);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroV2; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(870);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9180);
/* harmony import */ var swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8352);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7239);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9735);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9741);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














function HeroV2(param1) {
    var heroItem = param1.heroItem, _hasFormNow = param1.hasFormNow, hasFormNow = _hasFormNow === void 0 ? false : _hasFormNow, height = param1.height;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), query = ref.query, isReady = ref.isReady;
    var bulletsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var isLarge = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__/* .useLargeQuery */ .fc)().isLarge;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), sliderCaptions = ref1[0], setSliderCaptions = ref1[1];
    var id1 = heroItem.id, name = heroItem.name, banner = heroItem.banner, color_primary = heroItem.color_primary, hotel_code = heroItem.hotel_code, slider = heroItem.slider, is_parador = heroItem.is_parador, has_banner = heroItem.has_banner;
    var BannerHeading = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        function f() {
            return _f.apply(this, arguments);
        }
        function _f() {
            _f = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
                var temp;
                return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            _ctx1.next = 2;
                            return Promise.all(slider.map(function() {
                                var _ref = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                                    var id, x, y;
                                    return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                id = param.id;
                                                _ctx.next = 3;
                                                return (0,_utils_api__WEBPACK_IMPORTED_MODULE_11__/* .getWPImage */ .Mu)(id);
                                            case 3:
                                                x = _ctx.sent;
                                                _ctx.next = 6;
                                                return x.data.caption;
                                            case 6:
                                                y = _ctx.sent;
                                                if (y) {
                                                    y = y.rendered.replace("<p>", "").replace("</p>\n", "");
                                                }
                                                return _ctx.abrupt("return", y);
                                            case 9:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()));
                        case 2:
                            temp = _ctx1.sent;
                            setSliderCaptions(temp);
                        case 4:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1);
            }));
            return _f.apply(this, arguments);
        }
        f();
    }, [
        isReady
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
        className: "hero-container-v2",
        ref: containerRef,
        h: "800px",
        maxH: "800px",
        children: [
            !is_parador || has_banner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BannerHeading, {
                className: "banner",
                as: "h1",
                size: "lg",
                fontWeight: 300,
                letterSpacing: "widestx",
                textAlign: "center",
                children: banner
            }) : null,
            slider && slider.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .Swiper */ .tq, {
                lazy: true,
                centeredSlides: true,
                speed: 1000,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                loop: slider.length > 1,
                pagination: {
                    clickable: true
                },
                navigation: true,
                modules: slider.length > 1 ? [
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt,
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl,
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_
                ] : [],
                className: "mySwiper",
                onInit: function(swiper) {
                    if (slider.length > 1) {
                        swiper.navigation.init();
                        swiper.navigation.update();
                    }
                },
                children: slider && slider.map(function(image, i) {
                    var _i;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                            className: "image-container",
                            h: "800px",
                            width: "100%",
                            children: [
                                !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(sliderCaptions[i]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    className: "slider-caption",
                                    zIndex: 9,
                                    position: "absolute",
                                    fontWeight: 500,
                                    fontSize: [
                                        "x-small",
                                        "small"
                                    ],
                                    bottom: [
                                        "2px",
                                        "24px"
                                    ],
                                    opacity: [
                                        0.5,
                                        1
                                    ],
                                    right: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__/* .safeMarginX */ .Mp,
                                    color: "white",
                                    children: (_i = sliderCaptions[i]) !== null && _i !== void 0 ? _i : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    h: "100%",
                                    w: "100%",
                                    bg: is_parador && hasFormNow ? "blackAlpha.400" : "blackAlpha.700",
                                    zIndex: 5
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: "image-slider",
                                    src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .convertImgHttps */ .Nu)(image.url),
                                    alt: "".concat(name, " slide ").concat(i + 1),
                                    layout: "fill",
                                    sizes: "(max-width: 640px) 100vw, (max-width: 1200px) 100vw, 100vw",
                                    priority: i === 0,
                                    quality: i === 0 ? 85 : 75,
                                    objectFit: "cover",
                                    loading: i === 0 ? "eager" : "lazy",
                                    unoptimized: true
                                })
                            ]
                        })
                    }, i);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                h: "800px",
                bg: "gray.400"
            })
        ]
    });
};


/***/ }),

/***/ 6830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./src/components/HeroV2.tsx
var HeroV2 = __webpack_require__(2699);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/components/ItemGridStore.tsx





function ItemGridStore(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, price = param.price, slug = param.slug;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        direction: "column",
        w: "100%",
        justify: "space-between",
        gap: 2,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                direction: "column",
                gap: 2,
                color: "blackAlpha.700",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AspectRatio */.oM5, {
                        ratio: 4 / 3,
                        maxW: "100%",
                        position: "relative",
                        cursor: "pointer",
                        onClick: function() {
                            return router.push("/shop/detail?product=".concat(slug));
                        },
                        children: thumb ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            alt: "",
                            src: thumb,
                            objectFit: "cover",
                            priority: true,
                            unoptimized: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            bg: "gray.100"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Tooltip */.ua7, {
                        label: title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            as: "h4",
                            fontWeight: 400,
                            fontSize: "13px",
                            letterSpacing: 1,
                            color: "black",
                            mt: 3,
                            noOfLines: 2,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        fontSize: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: (0,functions/* formatRupiah */.b7)(price)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        fontSize: "sm",
                        letterSpacing: 0.2,
                        lineHeight: 1.2,
                        noOfLines: 2,
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                gap: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                    variant: "outline",
                    bg: "white",
                    color: "black",
                    borderColor: "black",
                    _hover: {
                        bg: "black",
                        color: "white"
                    },
                    onClick: function() {
                        return router.push("/shop/detail?product=".concat(slug));
                    },
                    children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ItemListStore.tsx





function ItemListStore(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, price = param.price, slug = param.slug;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        h: "100%",
        w: "100%",
        gap: 10,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                h: "60vh",
                w: "65%",
                position: "relative",
                cursor: "pointer",
                onClick: function() {
                    return router.push("/shop/detail?product=".concat(slug));
                },
                children: thumb ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    alt: "",
                    src: thumb,
                    objectFit: "cover",
                    priority: true,
                    unoptimized: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                    bg: "gray.100"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                w: "35%",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    direction: "column",
                    gap: 2,
                    color: "blackAlpha.700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            as: "h2",
                            fontWeight: 400,
                            fontSize: "xl",
                            letterSpacing: 4,
                            color: "black",
                            mt: 3,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            fontSize: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: (0,functions/* formatRupiah */.b7)(price)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            fontSize: "sm",
                            letterSpacing: 0.2,
                            lineHeight: 1.2,
                            children: desc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            gap: 4,
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                variant: "outlineWhite",
                                color: "black",
                                _hover: {
                                    bg: "black",
                                    color: "white"
                                },
                                borderColor: "black",
                                onClick: function() {
                                    return router.push("/shop/detail?product=".concat(slug));
                                },
                                children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/containers/Helmet.tsx + 1 modules
var Helmet = __webpack_require__(9536);
// EXTERNAL MODULE: ./src/layout/Footer.jsx
var Footer = __webpack_require__(3981);
// EXTERNAL MODULE: ./src/layout/HeaderV3.tsx + 4 modules
var HeaderV3 = __webpack_require__(4850);
// EXTERNAL MODULE: ./src/layout/Section.jsx
var Section = __webpack_require__(1914);
// EXTERNAL MODULE: ./src/utils/hooks.js + 1 modules
var hooks = __webpack_require__(1127);
// EXTERNAL MODULE: ./src/utils/mediaQuery.js
var mediaQuery = __webpack_require__(9741);
;// CONCATENATED MODULE: ./src/pages/shop/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}














var __N_SSG = true;
function Home(param1) {
    var header = param1.header, hotelBrands = param1.hotelBrands, hero = param1.hero;
    var selectLangDesc = function selectLangDesc(str) {
        var final = {
            title_id: "",
            desc_id: "",
            desc_en: ""
        };
        str.split("///").map(function(x) {
            if (x.includes("title_id : ")) {
                final.title_id = x.replace("title_id : ", "").replace(/\r|\n|amp;/g, "");
            }
            if (x.includes("desc_id : ")) {
                final.desc_id = x.replace("desc_id : ", "").replace(/\r|\n|amp;/g, "");
            }
            if (x.includes("desc_en : ")) {
                final.desc_en = x.replace("desc_en : ", "").replace(/\r|\n|amp;/g, "");
            }
        });
        return final;
    };
    var selectLangSimple = function selectLangSimple(desc) {
        var split = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "///";
        var temp = desc !== null && desc !== void 0 ? desc : "";
        var finalDesc = temp;
        if (temp.includes(split)) {
            var x = temp.split(split);
            finalDesc = x[locale == "id" ? 1 : 0];
        }
        return finalDesc;
    };
    var ref = (0,next_router.useRouter)(), reload = ref.reload, query = ref.query, isReady = ref.isReady, replace = ref.replace, push = ref.push, locale = ref.locale;
    (0,react.useEffect)(function() {
        query.process == "done" && replace("/shop", undefined, {
            shallow: false
        });
    }, []);
    var ref1 = (0,react.useState)(8), count = ref1[0], setCount = ref1[1];
    var ref2 = (0,react.useState)(1), headerHeight1 = ref2[0], setHeaderHeight = ref2[1];
    var ref3 = (0,react.useState)(""), keywordCat = ref3[0], setKeywordCat = ref3[1];
    var ref4 = (0,react.useState)(""), selectedCat = ref4[0], setSelectedCat = ref4[1];
    var ref5 = (0,react.useState)(), cats = ref5[0], setCats = ref5[1];
    var ref6 = (0,react.useState)(null), products = ref6[0], setProducts = ref6[1];
    var ref7 = (0,react.useState)(0), totalProducts = ref7[0], setTotalProducts = ref7[1];
    var ref8 = (0,react.useState)("{ field: DATE, order: DESC }"), orderBy = ref8[0], setOrderBy = ref8[1];
    var ref9 = _slicedToArray((0,hooks/* useSWRGraphQL */.f4)("query p_cats {\n    productCategories {\n      nodes {\n        id\n        name\n        slug\n        image {\n          id\n          sourceUrl\n          srcSet\n        }\n      }\n    }\n  }"), 3), catData = ref9[0], isCatLoading = ref9[1], isCatError = ref9[2];
    var ref10 = _slicedToArray((0,hooks/* useSWRGraphQL */.f4)("query p_all {\n    products(first: ".concat(count, ', where: {category: "').concat(keywordCat, '", orderby: ').concat(orderBy, ', stockStatus: IN_STOCK, tagIn: "shop"}) {\n      nodes {\n        id\n        databaseId\n        slug\n        image {\n          id\n          altText\n          sourceUrl\n        }\n        name\n        ... on SimpleProduct {\n          price(format: RAW)\n          regularPrice(format: RAW)\n          id\n          databaseId\n        }\n        description(format: RAW)\n        shortDescription(format: RAW)\n      }\n    }\n  }')), 4), prodData = ref10[0], isProdLoading = ref10[1], isProdError = ref10[2], prodMutate = ref10[3];
    var ref11 = (0,react.useState)(false), isSelectedProdLoading = ref11[0], setSelectedProdLoading = ref11[1];
    (0,react.useEffect)(function() {
        setSelectedProdLoading(true);
        if (!isCatLoading && catData) {
            var tempCats = catData.productCategories.nodes;
            var finalCats = tempCats.map(function(tempCat) {
                var finalCatName = selectLangSimple(tempCat.name, "/");
                return _objectSpread({}, tempCat, {
                    name: finalCatName
                });
            });
            setCats(finalCats);
        }
        !isProdLoading && prodData && setProducts(prodData.products.nodes);
        prodData && setTotalProducts(prodData.products.nodes.length);
        setSelectedProdLoading(false);
    }, [
        catData,
        prodData,
        count,
        orderBy,
        selectedCat,
        locale
    ]);
    var isLarge = (0,mediaQuery/* useLargeQuery */.fc)().isLarge;
    var ref12 = (0,react.useState)("grid"), viewAs = ref12[0], setViewAs = ref12[1];
    (0,react.useEffect)(function() {
        if (!products) return;
        setViewAs(products.length > 2 || !isLarge ? "grid" : "list");
    }, [
        products,
        isLarge
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* default */.Z, {
                title: "Store | Parador Hotels & Resorts",
                description: locale == "id" ? "Selamat datang di toko online Parador Hotels! Kami menawarkan berbagai merchandise, voucher, dan souvenir hotel berkualitas tinggi untuk memenuhi kebutuhan Anda. Nikmati pengalaman belanja yang menyenangkan di toko online kami, dengan berbagai pilihan unik dan eksklusif, seperti pakaian, tas, mug, serta voucher hotel yang dapat diakses secara mudah dan cepat. Semua produk di toko online Parador Hotels dirancang untuk memberikan kenangan yang tak terlupakan bagi tamu hotel dan\xa0pelanggan\xa0kami." : "Welcome to the Parador Hotels online shop! We offer a variety of high-quality merchandise, vouchers, and hotel souvenirs to meet your needs. Enjoy a pleasant shopping experience on our online store, with unique and exclusive options such as clothing, bags, mugs, and easy and quick access to hotel vouchers. All products in the Parador Hotels online shop are designed to provide unforgettable memories for our hotel guests\xa0and\xa0customers.",
                image: "https://backend.parador-hotels.com/wp-content/uploads/2022/06/ALL-MERCH-BANNER-scaled.webp"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderV3/* default */.Z, {
                headerItem: header,
                isHomepage: true,
                getHeight: function(headerHeight) {
                    return setHeaderHeight(headerHeight);
                },
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroV2/* default */.Z, {
                hasFormNow: true,
                heroItem: hero,
                height: "calc(100vh - ".concat(headerHeight1, "px)")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                bg: "white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                                mb: 2,
                                mr: 20,
                                as: "h1",
                                fontWeight: 400,
                                letterSpacing: "wider",
                                color: header.color_primary,
                                children: locale == "id" ? "BELANJA" : "SHOP"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                align: "center",
                                color: "blackAlpha.600",
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                        cursor: "pointer",
                                        onClick: function() {
                                            push("/shop/cart");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoCartOutline */.toq, {
                                            size: 28,
                                            color: "inherit"
                                        })
                                    }),
                                    isLarge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                                h: "20px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                                    borderColor: "blackAlpha.500",
                                                    opacity: 1,
                                                    orientation: "vertical"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                onClick: function() {
                                                    return setViewAs("list");
                                                },
                                                cursor: "pointer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoListOutline */.mKE, {
                                                    color: viewAs === "list" ? header.color_primary : "inherit",
                                                    size: 28
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                onClick: function() {
                                                    return setViewAs("grid");
                                                },
                                                cursor: "pointer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoGridOutline */.zrF, {
                                                    color: viewAs === "grid" ? header.color_primary : "inherit",
                                                    size: 22
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                                h: "20px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                                    borderColor: "blackAlpha.500",
                                                    opacity: 1,
                                                    orientation: "vertical"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Select */.PhF, {
                                                fontSize: "sm",
                                                border: "none",
                                                _focus: {},
                                                p: 0,
                                                m: 0,
                                                onChange: function(e) {
                                                    return setOrderBy(e.target.value);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                        value: "{field: DATE, order: DESC}",
                                                        children: [
                                                            " ",
                                                            locale == "id" ? "TERBARU" : "LATEST"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "{field: PRICE, order: ASC}",
                                                        children: locale == "id" ? "HARGA TERENDAH" : "PRICE LOW TO HIGH"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "{field: PRICE, order: DESC}",
                                                        children: locale == "id" ? "HARGA TERTINGGI" : "PRICE HIGH TO LOW"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        gap: 8,
                        flexDir: [
                            "column-reverse",
                            null,
                            null,
                            "row"
                        ],
                        children: [
                            isCatLoading && !cats && !products ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                h: "50vh",
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Spinner */.$jN, {
                                    size: "xl"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                flex: 1,
                                flexDir: "column",
                                fontWeight: 500,
                                letterSpacing: "wide",
                                fontSize: "lg",
                                textTransform: "uppercase",
                                w: "full",
                                position: [
                                    "unset",
                                    null,
                                    null,
                                    "sticky"
                                ],
                                top: 20,
                                alignSelf: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        py: 3,
                                        px: 4,
                                        bg: "gray.400",
                                        color: "white",
                                        children: locale == "id" ? "Kategori" : "Category"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        py: 3,
                                        px: 4,
                                        bg: "gray.100",
                                        _hover: {
                                            bg: "gray.200"
                                        },
                                        onClick: function() {
                                            setSelectedCat("");
                                            setKeywordCat("");
                                        },
                                        color: selectedCat === "" ? "gray.600" : "gray.400",
                                        cursor: "pointer",
                                        children: locale == "id" ? "Semua" : "All"
                                    }),
                                    cats && cats.map(function(param) {
                                        var name = param.name, id = param.id, slug = param.slug;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            py: 3,
                                            px: 4,
                                            bg: "gray.100",
                                            _hover: {
                                                bg: "gray.200"
                                            },
                                            color: selectedCat == name ? "gray.600" : "gray.400",
                                            onClick: function() {
                                                setKeywordCat(slug);
                                                setSelectedCat(name);
                                            },
                                            cursor: "pointer",
                                            children: name
                                        }, id);
                                    })
                                ]
                            }),
                            isProdLoading && !products && isSelectedProdLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                h: "50vh",
                                flex: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Spinner */.$jN, {
                                    size: "xl"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                flex: 4,
                                children: [
                                    viewAs === "grid" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SimpleGrid */.MIq, {
                                        columns: [
                                            2,
                                            3,
                                            4
                                        ],
                                        spacing: [
                                            4,
                                            6,
                                            8
                                        ],
                                        w: "100%",
                                        rowGap: 16,
                                        children: products && products.map(function(item) {
                                            var name = selectLangDesc(item.description);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemGridStore, {
                                                thumb: item.image ? item.image.sourceUrl : undefined,
                                                title: locale == "id" && !!name.title_id ? name.title_id : item.name,
                                                desc: selectLangSimple(item.shortDescription),
                                                id: item.databaseId,
                                                price: item.price,
                                                slug: item.slug
                                            }, item.id);
                                        })
                                    }),
                                    viewAs === "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                        direction: "column",
                                        gap: [
                                            6,
                                            12
                                        ],
                                        w: "100%",
                                        children: products && products.map(function(item) {
                                            var name = selectLangDesc(item.description);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListStore, {
                                                thumb: item.image.sourceUrl,
                                                title: !!name.title_id ? name.title_id : item.name,
                                                desc: selectLangSimple(item.shortDescription),
                                                id: item.databaseId,
                                                price: item.price,
                                                slug: item.slug
                                            }, item.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !(totalProducts < count) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                        mt: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                            variant: "dark",
                            size: "md",
                            onClick: function() {
                                setCount(count + 8);
                            },
                            children: locale == "id" ? "Lebih Banyak" : "Load More"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ }),

/***/ 9180:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,6394,4939,3981,9774,2888,179], function() { return __webpack_exec__(3276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);